import { FormsTemplateStatus, FormsTemplateType } from '@commenda/types';
import { defaultDropAnimationSideEffects, DropAnimation } from '@dnd-kit/core';
import { DEFAULT_REQUIRED_CONTEXT_KEYS } from './types';
import type { FormDSL, TemplateMetadata } from '@commenda/types';

export {
  COMMENDA_OS_CATEGORY_ID,
  COMMENDA_OS_DATA_SOURCE,
  DEFAULT_MAX_FILE_SIZE_MB,
  DSLContextMarker,
  ENTRY_ID_KEY,
  RESOLVED_LABEL_PREFIX,
} from './dsl-constants';

export const STATUS_EDIT_OPTIONS = [
  { label: 'Draft', value: FormsTemplateStatus.DRAFT },
  { label: 'Live', value: FormsTemplateStatus.LIVE },
  { label: 'Completed', value: FormsTemplateStatus.COMPLETED },
];

// ---------- Resizable Panel Hook ----------

export type ResizeDirection = 'left' | 'right';
export enum ResizablePanelWidth {
  MIN = 200,
  MAX = 500,
  DEFAULT_LEFT = 288,
  DEFAULT_RIGHT = 320,
}

export enum ResizablePanelDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export const DEFAULT_TEMPLATE_METADATA: TemplateMetadata = {
  name: '',
  description: '',
  status: FormsTemplateStatus.DRAFT,
  version: '1.0.0',
  versionNote: '',
  key: '',
  keyName: '',
};

export const TYPE_EDIT_OPTIONS = [
  { label: 'Form Module', value: FormsTemplateType.FORM_MODULE },
  { label: 'Form Step', value: FormsTemplateType.FORM_STEP },
  { label: 'Form Template', value: FormsTemplateType.FORM_TEMPLATE },
];

// Default empty DSL
export const createEmptyDSL = (): FormDSL => ({
  version: '1.0.0',
  form: {
    id: `form-${Date.now()}`,
    title: 'New Form',
    type: 'multi-step',
    settings: {
      showWarningBeforeSubmitting: true,
      closeEnabled: true,
      progress: {
        showStepIndicator: true,
        showPercentComplete: true,
        allowStepNavigation: 'completed',
        showTimeEstimate: true,
      },
      validation: {
        strategy: 'onChange',
        showInlineErrors: true,
        scrollToError: true,
        validateOnMount: false,
      },
    },
    contextRequirements: {
      required: [...DEFAULT_REQUIRED_CONTEXT_KEYS],
    },
  },
  steps: [
    {
      id: `step-${Date.now()}`,
      title: 'Step 1',
      order: 1,
      estimatedMinutes: 5,
      modules: [
        {
          id: `module-${Date.now()}`,
          name: 'Section 1',
          order: 1,
          components: [],
        },
      ],
    },
  ],
});

export const FORM_BUILDER_DROP_ANIMATION: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.5',
      },
    },
  }),
  duration: 250,
  easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
};
